import { useArtGeneratorViewController } from 'modules/art/controllers';
import { ConfirmEmailView } from './ConfirmEmailView';
import { CropPhotoView } from './CropPhotoView';
import { EnteringEmailView } from './EnterEmailView/EnterEmailView';
import { FinishSelectView } from './FinishSelectView';
import { SelectVariantView } from './SelectVariantView';
import { UploadPhotoView } from './UploadPhotoView';
import { SelectBoardView } from './SelectBoardView';
import { StepModeValue } from 'modules/art/types';

export const CreateArtView = () => {
  const { ConfirmEmail, EnterEmail, FinishSelect, SelectBoard, Upload, Crop, ChooseVariant } =
    StepModeValue;

  const {
    step,
    image,
    emailData,
    isStartLoading,
    setStep,
    uploadImage,
    saveCrop,
    enterEmail,
    selectVariant,
    start,
    toBuilder,
    download,
    board,
    selectBoard,
  } = useArtGeneratorViewController(Upload);

  return (
    <>
      {/* temporarily hide the page by choosing the board color */}
      {/* {step === SelectBoard && <SelectBoardView selectBoard={selectBoard} />} */}

      {step === Upload && (
        <UploadPhotoView uploadImage={data => uploadImage(data, () => setStep(Crop))} />
      )}

      {step === Crop && (
        <CropPhotoView
          image={image}
          goBack={() => setStep(Upload)}
          uploadImage={uploadImage}
          saveCrop={saveCrop}
        />
      )}

      {step === ChooseVariant && (
        <SelectVariantView
          image={image}
          goBack={() => setStep(Crop)}
          select={selectVariant}
          board={board}
        />
      )}

      {step === EnterEmail && (
        <EnteringEmailView goBack={() => setStep(ChooseVariant)} enterEmail={enterEmail} />
      )}

      {step === ConfirmEmail && (
        <ConfirmEmailView
          isStartLoading={isStartLoading}
          emailData={emailData}
          goBack={() => setStep(EnterEmail)}
          start={start}
        />
      )}

      {step === FinishSelect && (
        <FinishSelectView
          download={download}
          toBuilder={toBuilder}
          isStartLoading={isStartLoading}
        />
      )}
    </>
  );
};
